















import Vue from "vue";
import { Component } from "vue-property-decorator";
import WsResponseModel from "../../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import EmployeesListResponse from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/EmployeeModels/EmployeesListResponse";
import EmployeesType from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Enums/EmployeesType";
@Component
export default class PageAdministrationComponent extends Vue {

    type: EmployeesType = EmployeesType.Administration;
    serviceModel:WsResponseModel<EmployeesListResponse> = null

    mounted(){
        this.$meta.setTitle('Администрация');
        this.$api.EmployeeService.GetEmployeesListEvent
            .once(this.onGetEmployeesList.bind(this));
        this.$api.EmployeeService.GetEmployeesList({
            Type : this.type,
        })
    }

    onGetEmployeesList(response: WsResponseModel<EmployeesListResponse>){
        if(response.IsSuccess)
            this.serviceModel = response;
    }
}
